<template>
  <div class="dimensional-square-lingbao">
    <div class="table-header-actions">
      <h5 style="color: #fff"><span></span>次元广场灵宝（在线）</h5>

      <el-radio-group v-model="compareType" size="small">
        <el-radio-button label="standard">标准对比</el-radio-button>
        <el-radio-button label="baseline">基线对比</el-radio-button>
      </el-radio-group>
    </div>

    <el-table
      class="my-table-hok_v1"
      size="mini"
      :data="tableData"
      :header-cell-style="{
        background: 'rgb(35, 36, 72)',
        color: 'rgb(188, 189, 212)',
        'font-size': '14px',
        'font-family': 'Microsoft YaHei, Microsoft YaHei-Regular',
        'font-weight': 'normal',
      }"
      :span-method="cellMerge"
    >
      <!-- 机型 -->
      <el-table-column prop="model" label="机型" width="120">
        <template #default="{ row }">
          <span>{{ row.model }}</span>
        </template>
      </el-table-column>

      <!-- 画质 -->
      <el-table-column prop="quality" label="画质" width="80">
        <template #default="{ row }">
          <span>{{ row.quality || "/" }}</span>
        </template>
      </el-table-column>

      <!-- 动作 -->
      <el-table-column prop="action" label="动作" width="160">
        <template #default="{ row }">
          <span style="color: rgb(51, 157, 255)">{{ row.action }}</span>
        </template>
      </el-table-column>

      <!-- 最近更新时间 -->
      <el-table-column prop="date" label="最近更新时间" width="170">
        <template #default="{ row }">
          <span
            :style="
              'margin-left:' + (row.level == 0 ? '0px' : '10px')
            "
          >
            {{ row.date || "--"
            }}<i
              style="cursor: pointer"
              v-if="row.level == 0 && row.show"
              @click="expandCheck(row)"
              :class="
                row.check ? 'el-icon-arrow-down' : 'el-icon-arrow-up'
              "
            ></i>
          </span>
          <span
            @click="expandCheckAdd(row)"
            style="color: #70c1f1; cursor: pointer"
            v-if="row.many"
            >(查看更多)</span
          >
        </template>
      </el-table-column>

      <!-- SVN -->
      <el-table-column prop="svn" label="SVN" width="100">
        <template #default="{ row }">
          <span>{{ row.svn || "--" }}</span>
        </template>
      </el-table-column>

      <!-- 帧率模式 -->
      <el-table-column prop="frame_rate" label="帧率模式" width="100">
        <template #default="{ row }">
          <span>{{ row.frame_rate || "/" }}</span>
        </template>
      </el-table-column>

      <!-- 结论 -->
      <el-table-column prop="result" label="结论" width="80">
        <template #default="{ row }">
          <span :style="{ color: getResultColor(row) }">{{ row.result }}</span>
        </template>
      </el-table-column>

      <!-- 指标列（标准 / 数值），按图2顺序遍历 -->
      <el-table-column
        v-for="metric in metricColumns"
        :key="metric.key"
        :label="metric.label"
      >
        <el-table-column label="标准" width="80">
          <template #default="{ row }">
            <span style="color: rgb(51, 157, 255)">{{
              row?.standard?.[metric.key] || "/"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="数值" width="80">
          <template #default="{ row }">
            <span :style="`color: ${getValueColor(row, metric.key)}`">{{
              row?.[metric.key] ?? "-"
            }}</span>
          </template>
        </el-table-column>
      </el-table-column>

      <!-- 链接 -->
      <el-table-column label="链接" width="80">
        <template #default="{ row }">
          <a
            v-if="row.url && row.url !== '--'"
            target="_blank"
            style="
              cursor: pointer;
              color: rgb(24, 144, 255);
              text-decoration: none;
            "
            :href="row.url"
            >查看</a
          >
          <span v-else>--</span>
        </template>
      </el-table-column>

      <!-- Perfdog 链接 -->
      <el-table-column label="Perfdog" width="80">
        <template #default="{ row }">
          <a
            v-if="row.link && row.link !== '--'"
            target="_blank"
            style="
              cursor: pointer;
              color: rgb(24, 144, 255);
              text-decoration: none;
            "
            :href="row.link"
            >查看</a
          >
          <span v-else>--</span>
        </template>
      </el-table-column>

      <!-- SVN 链接 -->
      <el-table-column label="SVN链接" width="90">
        <template #default="{ row }">
          <a
            v-if="row.svn_url && row.svn_url !== '--'"
            target="_blank"
            style="
              cursor: pointer;
              color: rgb(24, 144, 255);
              text-decoration: none;
            "
            :href="row.svn_url"
            >SVN链接</a
          >
          <span v-else>--</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import axios from "axios";
import { ElMessage } from "element-plus";

export default {
  name: "DimensionalSquareLingbao",
  props: {
    project: {
      type: [String, Number],
      default: 57,
    },
  },

  computed: {
    skinId() {
      return this.$route?.query?.skin_id;
    },
  },

  data() {
    return {
      compareType: "standard", // standard: 标准对比  baseline: 基线对比（仅UI呈现）
      tableData: [],
      originRes: {}, // 按机型/版本号存放的原始接口数据
      // 指标列：按图中"标准对比/基线对比"切换区域下方表格的列顺序排列
      // 其中 FD峰值(低于)、BigJank(/10min)(低于)、平均帧能耗(低于)
      // 为图3红色箭头标记的列，接口暂未返回对应数值，但列仍展示，数值列显示 "-"
      metricColumns: [
        { label: "平均帧率(高于)", key: "avg_fps" },
        { label: "帧率方差(低于)", key: "var_fps" },
        { label: "最低帧率(高于)", key: "min_fps" },
        { label: "CPU占用率均值(低于)", key: "avg_cpu" },
        { label: "内存峰值(低于)", key: "max_pss" },
        { label: "平均加载耗时(低于)", key: "avg_load_time" },
        { label: "FD峰值(低于)", key: "fd_peak" },
        { label: "Jank(/10min)(低于)", key: "jank" },
        { label: "BigJank(/10min)(低于)", key: "big_jank" },
        { label: "平均帧能耗(低于)", key: "avg_fps_power" },
      ],
    };
  },

  watch: {
    skinId() {
      this.fetchData();
    },
  },

  methods: {
    async fetchData() {
      if (!this.skinId) return;
      try {
        this.tableData = [];
        this.originRes = {};
        const { data } = await axios("/report/dimension_lingbao_data/", {
          params: {
            project: this.project,
            skin_id: this.skinId,
          },
        });

        // 接口格式与局外皮肤性能接口一致：data[model][action] = [entries...]
        for (const model in data) {
          this.originRes[model] = {};
          for (const action in data[model]) {
            const entries = data[model][action] || [];
            const show = entries.length > 1;
            this.originRes[model][action] = entries;
            entries.forEach((v) => {
              if (v.level == 0) {
                this.tableData.push(this.buildRow(model, action, v, show));
              }
            });
          }
        }
        this.recomputeMany();
      } catch (e) {
        console.error("dimension_lingbao_data 请求失败", e);
        ElMessage.error("次元广场灵宝数据获取失败");
      }
    },

    buildRow(model, action, v, show) {
      return {
        ...v,
        model,
        action,
        quality: v.quality || "",
        date: v.date || "",
        svn: v.svn,
        frame_mode: v.frame_mode,
        result: v.result,
        url: v.url || "",
        link: v.link || "",
        svn_url: v["svn链接"] || v.svn_url || "",
        standard: v.standard || {},
        show: !!show,
        check: true,
        many: false,
      };
    },

    cellMerge({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const model = row.model;
        const rows = this.tableData;
        let startIdx = -1;
        let count = 0;
        for (let i = 0; i < rows.length; i++) {
          if (rows[i].model === model) {
            if (startIdx === -1) startIdx = i;
            count++;
          }
        }
        if (rowIndex === startIdx && count > 1) {
          return { rowspan: count, colspan: 1 };
        } else if (count > 1) {
          return { rowspan: 0, colspan: 0 };
        }
      }
      if (columnIndex === 2) {
        const model = row.model;
        const action = row.action;
        const rows = this.tableData;
        let startIdx = -1;
        let count = 0;
        for (let i = 0; i < rows.length; i++) {
          if (rows[i].model === model && rows[i].action === action) {
            if (startIdx === -1) startIdx = i;
            count++;
          }
        }
        if (rowIndex === startIdx && count > 1) {
          return { rowspan: count, colspan: 1 };
        } else if (count > 1) {
          return { rowspan: 0, colspan: 0 };
        }
      }
    },

    getResultColor(row) {
      const result = row.result;
      if (result == "达标") {
        return "rgb(121, 217, 127)";
      } else if (result == "不达标") {
        return "rgb(255, 76, 55)";
      }
    },

    getValueColor(row, key) {
      const color = row?.color?.[key];
      if (color == "green") {
        return "rgb(121, 217, 127);";
      } else if (color == "red") {
        return "rgb(255, 76, 55);";
      } else {
        return "";
      }
    },

    // 展开/收起同一动作下的子版本（level 0 / level 1）
    expandCheck(data) {
      data.check = !data.check;
      const model = data.model;
      const action = data.action;
      if (!data.check) {
        const addData = this.originRes[model][action].filter(
          (v) => v.level != 0,
        );
        const list = addData.map((v) => this.buildRow(model, action, v, false));
        const index = this.tableData.findIndex(
          (r) =>
            r.model == model &&
            r.action == action &&
            r.date == data.date,
        );
        if (index !== -1) {
          this.tableData.splice(index + 1, 0, ...list);
        }
      } else {
        this.tableData = this.tableData.filter(
          (r) =>
            !(
              r.model === model &&
              r.action === action &&
              r.level === 1
            ),
        );
      }
      this.recomputeMany();
    },

    // 「查看更多」——调用 /report/dimension_lingbao_data/，action 传 id_label
    async expandCheckAdd(data) {
      const model = data.model;
      const action = data.action;
      const page = this.tableData.filter(
        (r) => r.model == model && r.action == action,
      ).length;
      try {
        const { data: moreData } = await axios("/report/dimension_lingbao_data/", {
          params: {
            project: this.project,
            skin_id: this.skinId,
            device_name: model,
            page,
            action,
          },
        });

        if (moreData && moreData.length > 0) {
          const list = [];
          moreData.forEach((v) => {
            this.originRes[model][action].push(v);
            list.push(this.buildRow(model, action, v, false));
          });
          this.insertAfterLastOccurrenceAdd(model, action, list);
          this.recomputeMany();
        } else {
          ElMessage.error("暂无更多数据");
        }
      } catch (e) {
        console.error("dimension_lingbao_data 查看更多请求失败", e);
        ElMessage.error("查看更多数据获取失败");
      }
    },

    insertAfterLastOccurrenceAdd(model, action, newDevice) {
      let lastIndex = -1;
      this.tableData.forEach((device, index) => {
        if (device.model === model && device.action === action) {
          lastIndex = index;
        }
      });
      if (lastIndex !== -1) {
        this.tableData.splice(lastIndex + 1, 0, ...newDevice);
      } else {
        this.tableData.push(...newDevice);
      }
    },

    recomputeMany() {
      const occurrenceCount = {};
      const lastOccurrence = {};
      this.tableData.forEach((device, index) => {
        let key = `${device.model}_${device.action}`;
        if (!occurrenceCount[key]) occurrenceCount[key] = 0;
        occurrenceCount[key]++;
        lastOccurrence[key] = index;
      });
      this.tableData.forEach((device, index) => {
        let key = `${device.model}_${device.action}`;
        if (occurrenceCount[key] > 1) {
          device.many = index === lastOccurrence[key];
        } else {
          device.many = false;
        }
      });
    },
  },

  mounted() {
    this.fetchData();
  },
};
</script>

<style scoped>
.dimensional-square-lingbao {
  margin-top: 20px;
}

.table-header-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.table-header-actions h5 {
  margin: 0;
}

.el-table {
  --el-bg-color: transparent;
}

.el-table :deep(th),
.el-table :deep(tr),
.el-table :deep(td),
.el-table :deep(tr:hover),
.el-table :deep(tr:hover td) {
  color: #fff;
  background-color: rgb(34, 37, 41);
  border-bottom: 1px solid #606469;
}

.el-table :deep(tr:hover td) {
  color: #4ed8da;
}

.my-table-hok_v1 :deep(.el-table__row .cell) {
  background: rgb(35, 36, 72);
  color: rgb(188, 189, 212);
  font-size: 14px;
  font-family: "Microsoft YaHei", "Microsoft YaHei-Regular";
}

/* 表头不换行 */
.my-table-hok_v1 :deep(th .cell) {
  white-space: nowrap;
}

.el-table :deep(.el-table__body-wrapper) {
  background-color: rgb(34, 37, 41);
}
</style>
